import { useState } from "react";
import { auth } from "../firebase";

import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [isRegistering, setIsRegistering] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      navigate("/");
      console.log("Logged in successfully.");
    } catch (err) {
      console.error("Google login error:", err.message);
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      if (isRegistering) {
        await createUserWithEmailAndPassword(auth, email, password);
        setMessage("Account created! You're now logged in.");
        navigate("./");
      } else {
        await signInWithEmailAndPassword(auth, email, password);
        setMessage("Logged in successfully.");
        navigate("/");
        console.log("Logged in successfully.");
      }
    } catch (err) {
      console.error(err.message);
      setMessage(`Error: ${err.message}`);
    }
  };

  return (
    <>
      <Header />
      <div className="login-box">
        <h2>{isRegistering ? "Register" : "Sign in"}</h2>

        <button className="google-signin" onClick={signInWithGoogle}>
          <img src="./img/googleg.png" width="20px" alt="Google logo" />
          Continue with Google
        </button>

        <div className="or-divider">
          <span>or</span>
        </div>

        <form onSubmit={handleEmailSubmit}>
          <input type="email" name="email" placeholder="Email" required />
          <input
            type="password"
            name="password"
            placeholder="Password"
            required
          />
          <button type="submit">
            {isRegistering ? "Create Account" : "Login with Email"}
          </button>
        </form>
        {message && (
          <p style={{ color: message.startsWith("Error") ? "var(--status-error)" : "var(--accent)", marginTop: "1rem" }}>
            {message}
          </p>
        )}
        <p style={{ marginTop: "1rem", color: "var(--text-2)", fontSize: "var(--font-size-small)" }}>
          {isRegistering
            ? "Already have an account?"
            : "Don't have an account?"}{" "}
          <span
            className="login-register"
            onClick={() => setIsRegistering(!isRegistering)}
          >
            {isRegistering ? "Log in" : "Register"}
          </span>
        </p>
      </div>
    </>
  );
}
